import BackendOrderManager from 'admin/order';

export default BackendOrderManager;
export const orderNum = 6;
export const title = '訂單查詢';
